import React from "react";

/**
 * Serves WebP with automatic fallback to original jpg/png.
 * Uses HTML <picture> element for maximum browser compatibility.
 */
const WebPImage = ({
  src,
  alt,
  className,
  style,
  loading = "lazy",
  width,
  height,
  ...rest
}) => {
  // Generate WebP src by replacing extension
  const webpSrc = src ? src.replace(/\.(jpg|jpeg|png)$/i, ".webp") : src;

  return (
    <picture>
      <source srcSet={webpSrc} type="image/webp" />
      <img
        src={src}
        alt={alt}
        className={className}
        style={style}
        loading={loading}
        width={width}
        height={height}
        {...rest}
      />
    </picture>
  );
};

export default WebPImage;
